import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import squadService from '../../services/squadService';
import projectService from '../../services/projectService';
import { toast } from 'react-toastify';

const SquadForm = ({ isEdit = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    squad_code: '',
    project_id: '',
    organization_id: '',
    status: 'Active',
  });

  useEffect(() => {
    fetchProjects();

    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    if (storedUser?.organization_id) {
      setFormData((prev) => ({
        ...prev,
        organization_id: storedUser.organization_id,
      }));
    }

    if (isEdit && id) {
      fetchSquad();
    }
  }, [isEdit, id]);

  const fetchProjects = async () => {
    try {
      const data = await projectService.getAllProjects();
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };


  const fetchSquad = async () => {
    try {
      setLoading(true);
      setError(null);
    } catch (err) {
      setError('Failed to fetch squad');
      console.error('Error fetching squad:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const squadData = { ...formData };

      if (isEdit) {
        const response = await squadService.updatesquads(id, squadData);
        toast.success(response?.message || 'Squad updated successfully');
      } else {
        const response = await squadService.createsquads(squadData);
        toast.success(response?.message || 'Squad created successfully');
      }

      navigate('/app/squads');
    } catch (err) {
    //   setError(err.response?.data?.message || 'Failed to save squad');
      toast.error(err.response?.data?.error || err.response?.data?.message || 'Failed to save squad');
      console.error('Error saving squad:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/app/squads');
  };

  if (loading && isEdit) {
    return <div className="loading">Loading Squad...</div>;
  }

  return (
    <div className="milestone-form-container">
      <div className="milestone-form-header">
        <h2>{isEdit ? 'Edit Squad' : 'Create New Squad'}</h2>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit} className="milestone-form">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-4">
          <div className="form-group">
            <label htmlFor="name">Squad Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              required
              placeholder="Enter squad name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="squad_code">Squad Code *</label>
            <input
              type="text"
              id="squad_code"
              name="squad_code"
              value={formData.squad_code}
              onChange={handleChange}
              className="form-control"
              required
              placeholder="e.g. SQD-15"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div className="form-group">
            <label htmlFor="project_id">Project *</label>
            <select
              id="project_id"
              name="project_id"
              value={formData.project_id}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Project</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name} ({project.code})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="status">Status *</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Saving...' : (isEdit ? 'Update Squad' : 'Create Squad')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SquadForm;